import axios from "axios";

export default axios.create({
    // baseURL: "http://mewlink.asuscomm.com:12970",
    baseURL: "https://firelooks.kr:12970",
});